import React, {createContext, Dispatch, SetStateAction, useRef, useState} from 'react';
import {ActionType} from "@ant-design/pro-components";

//create a context, with createContext api
type ContextType = {
    authorizing?: boolean
    setAuthorizing?: Dispatch<SetStateAction<boolean>>
    //
    isExtensiveModalVisible?: boolean
    setIsExtensiveModalVisible?: Dispatch<SetStateAction<boolean>>
    isExtensiveCustomerModalVisible?: boolean
    setIsExtensiveCustomerModalVisible?: Dispatch<SetStateAction<boolean>>
}

export const GlobalStateContext = createContext<ContextType>({});


const GlobalStateProvider = ({children}: any) => {
    // this state will be shared with all components
    const [authorizing, setAuthorizing] = useState<boolean>(true);
    //
    const [isExtensiveModalVisible, setIsExtensiveModalVisible] = useState<boolean>(false);
    const [isExtensiveCustomerModalVisible, setIsExtensiveCustomerModalVisible] = useState<boolean>(false);

    return (
        // this is the provider providing state
        <GlobalStateContext.Provider value={{
            authorizing,
            setAuthorizing,
            //
            isExtensiveModalVisible,
            setIsExtensiveModalVisible,
            isExtensiveCustomerModalVisible,
            setIsExtensiveCustomerModalVisible
        }}>
            {children}
        </GlobalStateContext.Provider>
    );
};

export default GlobalStateProvider;